import styled from "styled-components";

export const IConnectedWeldWrapper = styled.div`
    height:400px;

`